import React from 'react';
import PropTypes from 'prop-types'
import './SupportForms.scss';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../../Common/TextArea';
import InputText from '../../Common/InputText';
import { MAX_SUPPORT_TICKET_CHAR_LENGTH } from '../../../constants/constants';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';

const GeneralSupport = ({ locations, projects, faqs, ticket, onFormChange, isFormValid, isProjectEnabled, isLoadingProjects }) => {

    const onTextChange = (e) => {
        onFormChange(e.target.name, e.target.value);
    }

    const onSelectChange = (id, name) => {
        const newValue = (!id) ? "" : id;
        onFormChange(name, newValue);
    }

    return (
        <div>
            <div className="row">
                <div className="col-12 mb-2">
                    <span className="support-header">Answers to frequent questions</span>
                </div>
            </div>
            {faqs.length > 0 ?
                ""
            :
                <p>There are no frequently asked questions.</p>
            }
            {faqs.map(faq => (
                <div className="faqs" key={faq.question}>
                    <div className="col-12"><strong>{faq.question}</strong></div>
                    <div className="col-12">{faq.answer}</div>
                    <br />
                </div>
            ))}
            <div className="row">
                <div className="col-12 mb-2">
                    <span className="support-header">Ask a question that is not listed above</span>
                </div>
            </div>
            <div className="support-home-form">
                <form noValidate className={isFormValid ? "" : "was-validated"}>
                    {locations.length > 0 &&
                        <MultiSelectBox name="locationId" label="Locations" options={locations} idField="id" valueField="name" onChange={onSelectChange} selectedValues={ticket.locationId.toString()} isMulti={false} isRequired={true} />
                    }
                    {isProjectEnabled && projects.length > 0 &&
                        <LoadingIndicator isLoading={isLoadingProjects}>
                            <MultiSelectBox name="projectId" label="Projects" options={projects} idField="id" valueField="name" onChange={onSelectChange} selectedValues={ticket.projectId.toString()}  isMulti={false} isRequired={false} />                        
                        </LoadingIndicator>
                    }
                    <InputText name="subject" label="Subject" placeholder="Subject" type="text" errorMessage="Subject required" isRequired={true} onChange={onTextChange} value={ticket.subject} />
                    <TextArea name="description" label="Question/Comment" rows={5} placeholder="Question/Comment" onChange={onTextChange} maxLength={MAX_SUPPORT_TICKET_CHAR_LENGTH} errorMessage="Question required" isRequired={true} value={ticket.description} />
                    <div className="remaining-chars text-end">{ticket.description.length}/{MAX_SUPPORT_TICKET_CHAR_LENGTH}</div>
                </form>
            </div>
        </div>
    )

}

GeneralSupport.propTypes = {
    ticket: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    faqs: PropTypes.array.isRequired,
    projects: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    isProjectEnabled: PropTypes.bool.isRequired,
    isLoadingProjects: PropTypes.bool.isRequired
};

export default GeneralSupport;
